export const INITIAL_AUTOCONNECT_TIMEOUT_MS = 10_000;
